import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { actionTypes as appActionTypes, selectors as appSelectors  } from '../features/app'
import { selectors as valuationSelectors  } from '../features/valuation'
import { selectors as errorSelectors } from '../features/error'
import ContactForm from '../forms/Contact'
import { AnalyticElement, IAnalyticEvent, Routes } from '../types.d'
import { scrollToBeginning } from '../helpers'
import SendEvent from '../analytics'
import { EAppVersion } from '../features/app/types'

export const Personal: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const version = useSelector(appSelectors.getAppVersion);
  const isLoading = useSelector(appSelectors.getAppIsLoading);
  const isError = useSelector(errorSelectors.getErrorTitle);
  const [isInit, setIsInit] = useState(false);
  const offerId = useSelector(appSelectors.getAppOfferId);
  const valuation = useSelector(valuationSelectors.getValuationValuation);

  const handleContactSubmit = () => {
    SendEvent({
      event: 'formSubmit',
      formName: 'contact'
    });
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
    history.push(Routes.Offer);
  }
  const handleDealerLoaded = (results: any) => {
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });
  };
  const handleAnalyticEvent = (evt: IAnalyticEvent) => {
    switch (evt.element){
      case AnalyticElement.Button:
        SendEvent({
          event: 'sendEvent',
          eventCategory: 'User Interactions',
          eventAction: `Instant Offer - contact`,
          eventLabel: `${version == EAppVersion.a ? 'Show' : 'Email'} valuation - button click`,
          eventValue: 0,
          nonInteraction: false
        });
        break;
    }
  }
  useEffect(() => {
    if (!isInit){
      setIsInit(true);
      // if (!valuation) history.replace(Routes.Specs); 
      dispatch({ type: appActionTypes.SET_APP, payload: { step: 2, subStep: 0 } });
      scrollToBeginning();
      SendEvent({
        event: 'sendVirtualPageView',
        pageType: 'instantoffer',
        viewSection: 'form',
        viewName: 'personal',
      });
    }
  })

  return (
    <Fragment>
      <section className={`i-step-all ${isLoading || isError ? 'i-loading' : ''}`}>
        <div className="i-con">
          <div className="i-row i-step-all-row">
            <div className="i-col">
              <h2>Finally, please provide your contact details</h2>
            </div>
            <div className="i-col">
              {/* <div className="i-text-group i-large">Submit your details to be {version == EAppVersion.a ? 'presented' : 'emailed '} with our offer (subject to a final inspection by the&nbsp;dealer)</div> */}
              <div className="i-text-group i-large">We&rsquo;ll need your details before we can present you with an offer to buy your vehicle (subject to a final inspection by your&nbsp;Dealer).</div>
              <ContactForm handleAnalyticEvent={handleAnalyticEvent} handleContactSubmit={handleContactSubmit} handleDealerLoaded={handleDealerLoaded} />
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  )
}
